import React from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import EbookReaderGuide from "../../blogs/EbookReaderGuide";
import Title from "./../../components/Title";
import Subtitle from "./../../components/Subtitle";
import "./articles.css";
import MakeGames from "../../blogs/MakeGames";
import BinaryComplements from "../../blogs/BinaryComplements";
import Page from "../../components/Page";
const BASE_ROUTE = "/articles";

const LinkToArticle = ({ article }) => {
  const navigate = useNavigate();
  return (
    <div
      className="link-to-article"
      onClick={() => {
        navigate(BASE_ROUTE + article.path);
      }}
      style={{
        margin: "1rem",
        cursor: "pointer",
        border: "1px solid hsla(0,0%,100%,.1)",
        borderRadius: "12px",
        width: "500px",
        display: "flex",
        flex: 1,
        paddingInline: "1rem",
        flexDirection: "column",
      }}
    >
      <Title>{article.title}</Title>
      <Subtitle>{article.description}</Subtitle>
    </div>
  );
};

const ArticlesHome = () => {
  return (
    <div
      style={{
        paddingInline: "50px",
      }}
    >
      <h2 className="title-block-header">Blogs & Essays</h2>
      <LinkToArticle
        article={{
          path: "/ebook-reader-guide",
          title: "My E-Book Reading Setup",
          description: "A setup guide",
        }}
      />
      <LinkToArticle
        article={{
          path: "/make-games",
          title: "Are You A Beginner Developer? - Try Making Games",
          description: "",
        }}
      />
      <LinkToArticle
        article={{
          path: "/binary-complements",
          title: "Making Sense of 2's Complement Number and others",
          description:
            "A study of 2's complement, and some other binary notations, and where they came from.",
        }}
      />
    </div>
  );
};

const Article = () => {
  const loc = useLocation();

  const renderBlog = () => {
    switch (loc.pathname) {
      case BASE_ROUTE + "/ebook-reader-guide":
        return <EbookReaderGuide />;
      case BASE_ROUTE + "/make-games":
        return <MakeGames />;
      case BASE_ROUTE + "/binary-complements":
        return <BinaryComplements />;
      default:
        return <ArticlesHome />;
    }
  };

  return <Page>{renderBlog()}</Page>;
};

export default Article;
